<div class="modal-header">
  <h4 class="modal-title pull-left">{{ modalTitle }}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="decline()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  {{ modalMessage }}
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    (click)="confirm()"
    [disabled]="modalConfirmDisabled"
    translate
  >
    COMMON.YES
  </button>
  <button type="button" class="btn btn-light ml-1" (click)="decline()" translate>COMMON.NO</button>
</div>
